import { Handle, Position } from "@xyflow/react";

const TopHandle = () => (
  <Handle
    type="target"
    position={Position.Top}
    style={{ visibility: "hidden" }}
  />
);

export default TopHandle;
